import { STATI } from "@/lib/api";

const STYLES = {
  aperto: "bg-amber-50 text-amber-800 border-amber-300",
  in_lavorazione: "bg-blue-50 text-blue-800 border-blue-300",
  completato: "bg-emerald-50 text-emerald-800 border-emerald-300",
  consegnato: "bg-purple-50 text-purple-800 border-purple-300",
};

export const StatusBadge = ({ stato, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center gap-1.5 rounded-sm border px-2 py-0.5 text-[11px] font-bold uppercase tracking-wider ${STYLES[stato] || ""}`}
  >
    <span className="h-1.5 w-1.5 rounded-full bg-current" />
    {STATI.find((s) => s.value === stato)?.label || stato}
  </span>
);

export const StockBadge = ({ quantita, soglia, testId }) => {
  const low = Number(quantita) <= Number(soglia);
  return (
    <span
      data-testid={testId}
      className={`font-mono text-sm font-bold ${low ? "rounded-sm bg-rose-50 px-1.5 text-rose-700 ring-1 ring-rose-200" : "text-slate-900"}`}
    >
      {quantita}
    </span>
  );
};
